
// Import the functions you need from the SDKs you need


import { initializeApp } from "firebase/app";


import { getAuth } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use


// https://firebase.google.com/docs/web/setup#available-libraries





// Your web app's Firebase configuration


const firebaseConfig = {


  apiKey: "AIzaSyBFORp3qCsIgrEDm1xmO6I0LoO7EMbG9SU",


  authDomain: "chimera-project-9ee91.firebaseapp.com",


  projectId: "chimera-project-9ee91",


  storageBucket: "chimera-project-9ee91.firebasestorage.app",


  messagingSenderId: "277362753118",


  appId: "1:277362753118:web:e59d81ab4c7c8c0987becf"


};





// Initialize Firebase


const app = initializeApp(firebaseConfig);





export const auth = getAuth();


export default app;